
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-to-travel-sustainably-with-daymade",
      function () {
        return require("private-next-pages/blog/how-to-travel-sustainably-with-daymade.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-to-travel-sustainably-with-daymade"])
      });
    }
  